import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Footer = () => {
  // 회사 정보 가져오기 (있는 경우)
  const withcookieData = useSelector(state => state.withcookie?.withcookieData);
  const companyInfo = withcookieData?.company || {};
  
  return (
    <div className="site-footer_bottom">
      <div className="container">
        <div className="site-footer_bottom_copyright">
          <p><Link to="/">@ 한국 환경협회</Link></p>
        </div>
        <div className="site-footer_bottom_copyright">
          <p>고유번호 : {companyInfo.business_number || '497-82-00350'}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer; 